import { render, staticRenderFns } from "./mLayRight.vue?vue&type=template&id=4053ae35&scoped=true&"
import script from "./mLayRight.vue?vue&type=script&lang=js&"
export * from "./mLayRight.vue?vue&type=script&lang=js&"
import style0 from "./mLayRight.vue?vue&type=style&index=0&id=4053ae35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053ae35",
  null
  
)

export default component.exports